//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const Reorder = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="Reorder"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 0H4V3H7V0ZM7 6.5H4V9.5H7V6.5ZM4 13H7V16H4V13ZM12 0H9V3H12V0ZM9 6.5H12V9.5H9V6.5ZM12 13H9V16H12V13Z"
            fill="currentColor"
          />
        </svg>
      }
      {...restProps}
    />
  );
};
